import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ADIOrderDetailsDeliveryInfo from "./ADIOrderDetailsDeliveryInfo";
import ADIOrderDetailsOrderLinesList from "./ADIOrderDetailsOrderLinesList";
import ADIOrderDetailsOrderTotalDisplay from "./ADIOrderDetailsOrderTotalDisplay";

interface OwnProps {
    indexNum: number | undefined;
}

const mapStateToProps = (state: ApplicationState) => {
    const userRoles = state.context.session.userRoles;
    return {
        userRoles,
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface ADIOrderDetailsProductInformationStyles {
    container?: GridContainerProps;
    deliveryInfoContainer?: GridItemProps;
    cartsContainer?: GridItemProps;
    priceContainer?: GridItemProps;
    shipmentViewContainer?: GridContainerProps;
}

export const adiOrderDetailsProductInformationStyles: ADIOrderDetailsProductInformationStyles = {
    deliveryInfoContainer: {
        width: 2,
        css: css`
        @media only screen and (max-width: 1024px) {
            flex-basis: 100%;
            max-width: 100%;
            background: ${getColor("common.background")};
        }
        `
    },
    cartsContainer: {
        width: 7,
        css: css`
        @media only screen and (max-width: 1024px) {
            flex-basis: 100%;
            max-width: 100%;
            flex-direction: column;
            background: ${getColor("common.background")};
        }
        @media only screen and (max-width: 576px) {
            background: transparent;
        }
        `
    },
    priceContainer: {
        width: 3,
        css: css`
        @media only screen and (max-width: 1024px) {
            flex-basis: 100%;
            max-width: 100%;
            justify-content: center;
            margin-top: 12px !important;
            margin-bottom: 16px !important;
            background: ${getColor("common.background")};
        }
        `
    },
    shipmentViewContainer: {
        css: css`
        >${GridOffset}{
            border-top: 1px solid ${getColor("common.border")};
            padding-top: 12px;
            @media only screen and (max-width: 1024px) {
                border-top: 0;
            }
        }
        `
    },
};

const styles = adiOrderDetailsProductInformationStyles;

const ADIOrderDetailsProductInformation: FC<Props> = ({ userRoles, indexNum }) => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.orderLines) {
        return null;
    }

    return (
        <StyledWrapper>
            {order?.invoiceOrderLines.map((shipment: any, index: number) => {
                return (indexNum === index && <GridContainer {...styles.shipmentViewContainer} key={shipment?.id}>
                    <GridItem {...styles.deliveryInfoContainer}>
                        <ADIOrderDetailsDeliveryInfo shipment={shipment} userRoles={userRoles} order={order} />
                    </GridItem>
                    <GridItem {...styles.cartsContainer}>
                        <ADIOrderDetailsOrderLinesList order={order} shipment={shipment} />
                    </GridItem>
                    <GridItem {...styles.priceContainer}>
                        <ADIOrderDetailsOrderTotalDisplay shipment={shipment} />
                    </GridItem>
                </GridContainer>)
            })}
        </StyledWrapper>
    )
};

export default ADIOrderDetailsProductInformation;
